import { DiscussionPostFragment } from "@pathwright/graphql-client/src/generated"
import { useSyncPlanContext } from "../path/sync/SyncPlanContext"

// Conditionally refetch only when created/deleting a discussion type question from the Source Path.
// These are the only type of discussions that sync.
function useRefetchSyncPlanForDiscussion() {
  const syncPlanContext = useSyncPlanContext()

  return function (discussion: DiscussionPostFragment) {
    if (
      discussion?.is_discussion_question &&
      syncPlanContext?.fromPath?.is_source_path
    ) {
      syncPlanContext?.refetchSyncPlanQueries?.()
    }
  }
}

export default useRefetchSyncPlanForDiscussion
